<template>
    <div id="basket">

        <div v-if="!order.state.loading">
            <div class="container">
                <b-breadcrumb :items="breadcrumb"></b-breadcrumb>

                <div class="row">
                    <div class="d-none d-xl-block col-3">
                        <catalog-categories></catalog-categories>
                    </div>

                    <div class="col-xl-9">
                        <div class="d-flex row row-custom-message-alert mb-16">
                            <h1 class="as-h3 pr-3 col-sm-auto col-12" :class="{'color-text-grey': order.state.step > 1}">Корзина</h1>
                            <div class="title-3 text-uppercase" :class="{'color-text-grey': order.state.step  == 1}">Оформление заказа</div>
                        </div>

                        <div v-if="!items" class="font-500">
                            <p class="mb-1">Товаров в корзине еще нет.</p>
                            <p>Перейдите в
                                <router-link class="color-primary" to="/catalog">каталог</router-link>
                                и выберите необходимое для вас оборудование.
                            </p>
                        </div>


                        <div v-if="items && items.length > 0">
                            <div class="d-none d-md-block">
                                <price-information class="mb-24"></price-information>
                            </div>

                            <!-- *** STEP 1 *** -->
                            <div v-if="order.state.step  == 1">
                                <order-products @update="updateData"></order-products>
                                <price-information class="mb-24 d-none d-md-flex" v-if="items.length > 10"></price-information>
                                <price-information class="mb-24 d-block d-md-none"></price-information>
                            </div>

                            <!-- *** STEP 2 *** -->
                            <div v-if="order.state.step  == 2" class="basket-order">
                                <order-details @update="updateData" :services="services" :deliveries="deliveries" :user="user"></order-details>
                                <price-information class="mb-24"></price-information>
                            </div>

                            <!-- *** STEP 3 *** -->
                            <div v-if="order.state.step  == 3">
                                <order-check-user></order-check-user>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="order.state.loading" class="loading-box flex-column">
            <div class="color-text-dark">
                <p class="title-4 text-center">Ваш заказ формируется...</p>
                <p class="h5 text-center mb-40">Пожалуйста, не закрывайте страницу.</p>
            </div>
            <b-spinner></b-spinner>
        </div>

        <div v-if="store.state.loading" class="loading-box">
            <b-spinner></b-spinner>
        </div>
    </div>
</template>

<script>
    import store from '../../../services/data';
    import order from '../../../services/order';


    export default {
        data() {
            return {
                breadcrumb: [
                    {
                        text: 'Главная',
                        to: {name: 'pages-index'}
                    },
                    {
                        text: 'Корзина',
                        active: true
                    }
                ],
                store: store,
                order: order,

                items: null,
                services: [],
                deliveries: null,
            }
        },

        watch: {
            'order.state.step'() {
                if(this.order.state.step == 4) this.$store.dispatch('fetchUser');
            },
            'store.state.basket_items'() {
                this.items = this.store.state.basket_items;
            }
        },
        computed: {
            user() {
                return this.$store.getters.getUser;
            }
        },

        mounted() {
            this.getSeoInfo()
            this.order.state.step = 1;
            this.store.getBasketItems();
            this.getServices();
        },

        methods: {
            updateData() {
                this.items = null;
                this.store.getBasketItems();
            },

            getServices() {
                let url = '/api/get-services';
                axios.get(url).then(response => {
                    this.services = response.data.services;
                    let deliveries = response.data.deliveries;
                    deliveries.forEach(item => {
                        item.id = Number(item.id)
                    });
                    this.deliveries = deliveries;
                })
            },

            getSeoInfo(){
                let url = '/api/seo';

                let params = {
                    url: 'basket',
                };

                axios.post(url, params)
                    .then(response => {
                        let seoInfo = response.data.seoInfo

                        document.title = seoInfo?.seo_title ? seoInfo?.seo_title : 'Корзина заказа на сайте Фотопроката "MRental".';
                        let desc = seoInfo?.seo_desc ? seoInfo?.seo_desc : 'Оформляйте заказ на сайте Фотопроката "MRental" через корзину, и храните историю заказов в личном кабинете.';
                        document.querySelector('meta[name="description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[property="og:description"]').setAttribute("content",  desc);
                        document.querySelector('meta[name="twitter:text:description"]').setAttribute("content",  desc);
                    })
                    .catch(error => {
                        if (error) this.loading = false;
                    })
            }
        },
    }
</script>
